<template>
    <div>
        <b-modal
            :no-close-on-backdrop="true"
            modal-class="modals-approval gofixModal approval-multiple"
            size="lg"
            :title="title"
            hide-footer
            :centered="true"
            ref="modal-approval-log"
            v-model="modals.approval.open">
            <div class="actionAndRemarks modalPadding">
                <b-row>
                    <b-col class="col-remark">
                        <gofix-form-input-textarea label="remarks" class="mb-0 h-100" v-model="approval.remark"></gofix-form-input-textarea>
                    </b-col>
                    <b-col class="action">
                        <gofix-button
                            class="d-block mb-1 w-100"
                            label="Recommend for <br/> approval / Approve"
                            @click="approvalMultipe(null)"
                            outline />
                        <gofix-button
                            class="d-block mb-1 w-100"
                            label="Request for <br/> Revision"
                            @click="approvalMultipe('Request for Revision')"
                            outline />
                        <gofix-button
                            class="d-block w-100"
                            label="Reject"
                            @click="approvalMultipe('Reject')"
                            outline dark />
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" modal-class="modal-remove-padding" hide-footer hide-header :centered="true" v-model="modals.confirm.open">
            <div class="center">This action will be applied to <br/> <strong>{{approval.order_ids.length || approval.pv_ids.length || approval.credit_note_ids.length || approval.offset_ids.length}}</strong> selected item(s).<br/>Do you want to proceed?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.confirm.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="modals.confirm.loading" @click="confirmApproval"> 
                    <b-spinner v-if="modals.confirm.loading" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'approval-multiple',
        props: {
            title: {
                type: String,
                default: ''
            },
            value: {
                type: Boolean,
                default: false
            },
            orders: {
                type: Array,
                default: () => []
            },
            payments: {
                type: Array,
                default: () => []
            },
            credits: {
                type: Array,
                default: () => []
            },
            offsets: {
                type: Array,
                default: () => []
            }
        },
        data () {
            return {
                timer: null,
                modals: {
                    approval: {
                        open: this.value,
                    },
                    confirm: {
                        open: false,
                        loading: false
                    }
                },
                approval:{
                    order_ids: [],
                    pv_ids: [],
                    credit_note_ids: [],
                    offset_ids: [],
                    remark: null,
                    action: null
                }
            };
        },
        watch: {
            "modals.approval.open": function(val) {
                this.$emit('input', val);
            },
            "value": function(val) {
                if(val) {
                    this.approval.remark = null;
                    this.approval.action = null;
                }
                this.modals.approval.open = val;
            }
        },
        methods: {
            approvalMultipe(action){
                this.approval.order_ids = this.orders;
                this.approval.pv_ids    = this.payments;
                this.approval.credit_note_ids = this.credits;
                this.approval.offset_ids      = this.offsets;
                this.approval.action = action;
                this.modals.approval.open = false;
                this.modals.confirm.open  = true;
            },
            confirmApproval() {
                 if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if(this.modals.confirm.loading) return
                    this.modals.confirm.loading = true
                    
                    this.$store.dispatch("AwaitingApprovalController/createItem", this.approval)
                    .then(response => {
                        this.modals.confirm.loading = false;
                        this.modals.confirm.open    = false;
                        let msg = this.approval.order_ids.length ? 'order' : 'payment voucher';
                        this.$alertNotification(`Successfully approval ${msg}`);
                        this.$emit('approval-success');
                    })
                    .catch(err => {
                        console.log(err)
                        this.modals.confirm.loading = false;
                    })
                }, 300);
                
            }
        }
    }
</script>